// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-hidden {
    visibility: hidden;
}
.loader-background {
    position: absolute;
    z-index: 499999;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    -webkit-user-select: none;
    user-select: none;
    background-color: rgba(0,0,0,0.5);
}

.loader-overlay {
    position: absolute;
    top: calc(50vh - 100px);
    left: calc(50vw - 100px);
    opacity: 1;
    background: white;
    padding: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    z-index: 500000;
    -webkit-user-select: none;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/loader/loader.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;IAEzB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IAEzB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".loader-hidden {\n    visibility: hidden;\n}\n.loader-background {\n    position: absolute;\n    z-index: 499999;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    background-color: rgba(0,0,0,0.5);\n}\n\n.loader-overlay {\n    position: absolute;\n    top: calc(50vh - 100px);\n    left: calc(50vw - 100px);\n    opacity: 1;\n    background: white;\n    padding: 10px;\n    border: 1px solid #f0f0f0;\n    border-radius: 10px;\n    z-index: 500000;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
